import { NaeSSchemaMap } from "../config/NaeSSchema";

export const cacheData = (userState: any) => ([
        {
        schema: NaeSSchemaMap.User.schema,
        page: 1,
        pageSize: 200,
    },
        ]);